export let getLoggedUser = (state) => state.partner.byId[state.auth.logged_user]

export let getCurrentBusiness = (state) => state.business.byId[state.auth.current_business]

export let getCurrentBusinessAddress = (state) => state.address.byId[getCurrentBusiness(state).address]